import clsx from 'clsx';

import { Link } from '@common/atoms/Link';
import { Tag, TagType } from '@common/atoms/Tag';
import { WebpImage } from '@common/atoms/WebpImage';
import { WebpWidthEnum } from '@common/types/WebpWidth';
import { ItemTag } from '@web/atoms/ItemTag';

import { getNewsBlockListItemThemeConfig } from './NewsBlockListItem.config';
import { type NewsBlockListItemProps } from './types';

import styles from './NewsBlockListItem.module.scss';

export const NewsBlockListItem = ({
    contextData,
    index,
    src = '',
    title = '',
    category = {},
    newsSubtitle = '',
    metaIcon,
    count = 0,
    date = '',
    metaSuffix,
    url,
    isMetaHidden,
}: NewsBlockListItemProps) => {
    if (!contextData) {
        return null;
    }

    const themeConfig = getNewsBlockListItemThemeConfig(contextData);

    const metaString = date ? date : `${count} ${metaSuffix}`;

    const tagItem = {
        category: {
            ...category,
            showAsTag: !!newsSubtitle || !!category?.showAsTag,
        },
        newsSubtitle,
    };

    return (
        <li className={styles['NewsBlockListItem']}>
            <Link className={styles['link']} href={url}>
                {!isNaN(Number(index)) ? (
                    <Tag className={styles['counter']} type={TagType.COUNTER} contextData={contextData}>
                        {index}
                    </Tag>
                ) : null}
                <WebpImage
                    defaultSize={WebpWidthEnum.WIDTH_110}
                    className={styles['image']}
                    src={src}
                    alt={title}
                    ratio={1920 / 1080}
                />
                <div className={styles['content']}>
                    <h4
                        className={clsx(
                            styles['title'],
                            styles[`title--row-limit-${themeConfig.titleRowLimit}`],
                        )}
                    >
                        {!!themeConfig.showItemTag && tagItem.category.functionality !== 'premium' && (
                            <ItemTag
                                className={styles['item-tag']}
                                item={tagItem}
                                allowSubtitle
                                contextData={contextData}
                            />
                        )}
                        {title}
                    </h4>
                    {!isMetaHidden && !!themeConfig.showMeta && (
                        <div className={styles['meta']}>
                            {metaIcon ? metaIcon : null}
                            <span>{metaString}</span>
                        </div>
                    )}
                </div>
            </Link>
        </li>
    );
};
